import { HttpResponse } from 'msw';

export const checkAuth = (request: Request) => {
  const auth = request.headers.get('Authorization');
  if (!auth || !auth.startsWith('Bearer ')) {
    return new HttpResponse(null, { status: 401 });
  }
  return null;
};
